import { useEffect, useState, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { handleOAuthCallback } from './utils/handleOAuthCallback';
import { initializeAuth } from './utils/supabaseClient';

function App() {
  const [isProcessingAuth, setIsProcessingAuth] = useState(true);

  useEffect(() => {
    const processAuth = async () => {
      try {
        // Initialize auth first
        await initializeAuth();
        
        // Check if this is an OAuth callback
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const hasAuthParams = hashParams.has('access_token') || hashParams.has('error');

        if (hasAuthParams) {
          console.log('OAuth callback detected');
          
          try {
            const redirectPath = await handleOAuthCallback();
            
            // Clear the hash from URL
            window.history.replaceState(null, '', window.location.pathname);
            
            // Redirect to appropriate page
            if (redirectPath) {
              window.location.href = redirectPath;
              return;
            }
          } catch (error) {
            console.error('OAuth callback error:', error);
          }
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
      } finally {
        setIsProcessingAuth(false);
      }
    };

    processAuth();
  }, []);

  if (isProcessingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-rose-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-rose-50">
            <div className="text-center">
              <div className="w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-gray-600 font-medium">Loading...</p>
            </div>
          </div>
        }
      >
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
